import { useEffect, useState } from "react";
import { resolveImg, refreshFileToken } from "@/lib/api";

// Výřez fotky kolem špendlíku. background-position = poloha špendlíku v %:
// při zvětšeném pozadí tím bod (x, y) fotky padne přesně na (x, y) výřezu,
// takže značka sedí na místě závady bez ohledu na poměr stran fotky.
export function DefectCrop({ url, x, y, n, tone = "open", size = 56, zoom = 3.4, onClick, className = "" }) {
  const [ready, setReady] = useState(false);
  useEffect(() => { let on = true; refreshFileToken().then(() => on && setReady(true)); return () => { on = false; }; }, [url]);
  const bg = { open: "bg-brand", draft: "bg-brand", fixed: "bg-amber-500", accepted: "bg-success" }[tone] || "bg-brand";
  const Tag = onClick ? "button" : "span";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick}
      className={`relative block shrink-0 overflow-hidden rounded-[12px] border border-border bg-secondary bg-no-repeat ${className}`}
      style={{ width: size, height: size, backgroundImage: ready && url ? `url("${resolveImg(url)}")` : undefined,
        backgroundSize: `${zoom * 100}%`, backgroundPosition: `${x}% ${y}%` }}
      aria-label={n ? `Závada ${n}` : "Výřez fotky"}>
      {n != null && (
        <span className={`absolute w-5 h-5 -ml-2.5 -mt-2.5 rounded-full ${bg} text-white text-[10px] font-extrabold grid place-items-center border-2 border-white shadow`}
          style={{ left: `${x}%`, top: `${y}%` }}>{n}</span>
      )}
    </Tag>
  );
}
